import React from 'react'
import { Helmet } from 'react-helmet'
import Navbar from '../components/landing/Navbar'
import Hero from '../components/landing/Hero'
// import KeyNumbers from '../components/landing/KeyNumbers'
import Features from '../components/landing/Features'
import Security from '../components/landing/Security'
import AiMcp from '../components/landing/AiMcp'
import DashboardPreview from '../components/landing/DashboardPreview'
import Pricing from '../components/landing/Pricing'
import LandingFooter from '../components/landing/LandingFooter'

export default function Landing() {
  return (
    <div className="landing">
      <Helmet>
        <title>CloudyPocket — Vos finances personnelles, enfin sous contrôle</title>
        <meta name="description" content="CloudyPocket est une application gratuite de gestion de finances personnelles. Multi-comptes, budget, analytics, chiffrement AES-256 et intégration IA." />
        <meta property="og:title" content="CloudyPocket — Vos finances personnelles, enfin sous contrôle" />
        <meta property="og:description" content="Gérez vos comptes, budgets et dépenses simplement. Gratuit, sécurisé, intelligent." />
        <meta property="og:type" content="website" />
      </Helmet>

      <Navbar />
      <Hero />
      {/* TODO: Re-enable KeyNumbers section when we have meaningful KPIs to display
          (e.g. number of users, transactions processed, uptime, etc.)
          Also check competitors for inspiration on what metrics to highlight.
          <KeyNumbers /> */}
      <Features />
      <Security />
      <AiMcp />
      <DashboardPreview />
      <Pricing />
      <LandingFooter />
    </div>
  )
}
